import React from "react";

const Announcements: React.FC = () => {
  return <>ANNOUNCEMENTS PAGE</>;
};

export default Announcements;
